import bikeJSON from '../data/data';
// import getData from '../data/getData';
import Bike from './Bike';
import Range from './Range';

export default class SearchService  {

    constructor() {
        this.bikes = bikeJSON.bikes;
        this.heightRange = [];
    }

    matchBike(filter) {

        const height = filter.unit === 'inches' ? parseInt(filter.height, 10) : parseInt(filter.height / 2.54, 10);
        
        const bikeResult = this.bikes.filter((bike) => Number(height) === Number(bike.heightInch))[0];

        const bike = bikeResult ? bikeResult : this.bikes[0];

        return new Bike(bike.id, bike.type, bike.heightInch, bike.folder, bike.colors, bike.wheel);

    }

    defaultBike() {
        
        return new Bike(this.bikes[0].id, this.bikes[0].type, this.bikes[0].heightInch, this.bikes[0].folder, this.bikes[0].colors, this.bikes[0].wheel);
        
    }

    getNext(bike) {

        const currentWheel = bike.wheel;

        const wheelsAll = this.bikes.map(bike => bike.wheel);
        const wheels = Array.from(new Set(wheelsAll));

        const nextBikeArray = wheels.filter(wheel => wheel > currentWheel);

        return nextBikeArray.length ? `${nextBikeArray[0]} inch bike` : 'max bike size'
        
    }

    getFirstImages() {
        return this.bikes.map(bike => {
            return {"wheel": bike.wheel, "color": bike.colors[0], "folder": bike.folder, "type": bike.type }
        })
    }

    lastBike() {       
        
        const last = this.bikes.length - 1;
        return new Bike(this.bikes[last].id, this.bikes[last].type, this.bikes[last].heightInch, this.bikes[last].folder, this.bikes[last].colors, this.bikes[last].wheel);
    }

    getHeightRange() {

        this.bikes.map((bike) => this.heightRange.push(bike.heightInch));

        return new Range(Math.min(...this.heightRange), Math.max(...this.heightRange) )
    }

};




// WEBPACK FOOTER //
// ./src/classes/SearchService.js